<template>
  <aside ref="sidebar" class="mc-delivery-track-sidebar-history-trip">
    <div ref="sidebarWrapper" class="mc-delivery-track-sidebar-wrapper">
      <span ref="sidebarToggle" class="mc-delivery-track-sidebar-toggle">
        <div class="box-sidebar">
          <i class="mc-fa icon-fill_arrow-ios-left"></i>
          <i class="mc-fa icon-fill_arrowhead-right"></i>
        </div>
      </span>
      <h4 ref="sidebarHeader" class="mc-delivery-track-sidebar-header">
        {{ `Riwayat Perjalanan ${doNumber}` }}
        <span :disabled="disabledButtonHistoryTrip" class="toggle-btn" @click="clickToggle()">
          <i class="mc-fa icon-fill_arrowhead-left"></i>
        </span>
      </h4>
      <div ref="sidebarBody" class="mc-delivery-track-sidebar-body">
        <p>{{ 'Detail Perjalanan' }}</p>

        <McAlert
          v-if="actualPickOutOfOrder || actualDropOutOfOrder"
          class="mb-3"
          variant="warning"
          html="<strong>Rentang waktu di lokasi ambil atau kirim berbeda dengan perjalanan kendaraan"
          withIcon
          customIcon="icon-fill_info"
          :withGap="false"
          iconPosition="center"
        />

        <div v-if="hasFeatureEditActivityTrackDOMGM" class="date-range-history-mobile mb-2">
          <FormulateInput
            :key="historyDateRangeKey"
            v-model="historyDateRange"
            outer-class="w-100"
            name="dateRange"
            type="date-picker"
            datepickerType="datetime"
            value-type="YYYY-MM-DDTHH:mm:ss.SSSZ"
            format="DD MMM YYYY HH:mm"
            :range="true"
            :draft="true"
            :confirm="true"
            :cancel="true"
            confirmText="Terapkan"
            :disabled="isEditingLocationTime"
            :disabled-date="disabledHistoryDate"
            :available-range-text="historyAvailableRangeText"
          />
          <span
            v-if="historyDateRangeChanged"
            class="date-range-history-mobile__indicator"
            aria-hidden="true"
          ></span>
        </div>

        <div class="d-flex align-items-center justify-content-start text-muted mb-2">
          <i class="icon-fill_clock"></i>
          <p class="m-0">{{ formatDateTime() }}</p>
          <p class="m-0">|</p>

          <i class="icon-fill_driver-violation"></i>
          <p class="m-0">{{ val(liveMarker?.speed) }} Km/Jam</p>

          <!-- Temperature -->
          <p v-if="hasTmsColdChainAccess" class="m-0">|</p>
          <i v-if="hasTmsColdChainAccess" class="icon-fill_thermometer"></i>
          <p v-if="hasTmsColdChainAccess" class="m-0">{{ val(liveMarker?.temperature) }} °C</p>
          <p v-if="hasTmsColdChainAccess" class="m-0">|</p>
          <i
            v-if="hasTmsColdChainAccess && (liveMarker?.door1 === 0 || liveMarker?.door1 === 1)"
            :class="liveMarker.door1 === 1 ? 'icon-outline_door-open' : 'icon-outline_door-close'"
          ></i>

          <!-- LABEL -->
          <p v-if="hasTmsColdChainAccess" class="m-0">
            {{ liveMarker?.door1 === 1 ? 'Buka' : liveMarker?.door1 === 0 ? 'Tutup' : '-' }}
          </p>
        </div>
        <div class="sensor-controls d-flex justify-content-between">
          <select v-if="isMultiDoor" v-model="selectedDoor">
            <option>{{ 'Pintu 1' }}</option>
            <option>{{ 'Pintu 2' }}</option>
          </select>

          <select v-if="isMultiChamber" v-model="selectedTemperature">
            <option>{{ 'Suhu 1' }}</option>
            <option>{{ 'Suhu 2' }}</option>
            <option>{{ 'Suhu 3' }}</option>
          </select>
          <div class="sensor-box">
            <div class="form-check form-switch form-switch-sm">
              <input
                id="switchChart"
                v-model="sensorDataAnalysis"
                class="form-check-input"
                type="checkbox"
                @change="clickToggle()"
              />
              <label for="switchChart" class="switch-label">
                {{ 'Analisa Sensor' }}
                <i class="icon-outline_trending-up"></i>
              </label>
            </div>
          </div>
        </div>
        <hr />
        <div v-if="sensorDataAnalysis" class="d-flex w-100">
          <b-button-group class="flex-fill w-100">
            <b-button
              class="flex-fill"
              :variant="isChart ? 'info' : 'outline-info'"
              @click="toggleAnalysis('chart')"
            >
              <span><i class="icon-outline_trending-up"></i></span>
              {{ 'Grafik' }}
            </b-button>

            <b-button
              class="flex-fill"
              :variant="isChart ? 'outline-info' : 'info'"
              @click="toggleAnalysis('table')"
            >
              {{ 'Tabel' }}
            </b-button>
          </b-button-group>
        </div>
        <div v-if="sensorDataAnalysis" class="analysis-container">
          <div class="analysis-info">
            <div class="analysis-info-left">
              <p class="me-2">
                <strong>{{ isChart ? 'Grafik Sensor' : 'Tabel Sensor' }}</strong>
              </p>
              <McBadge
                v-if="isMultiChamber"
                :text="selectedTemperature"
                variant="outlineWarning"
                size="medium"
                type="button"
                :withDot="true"
                class="me-2"
              />
              <McBadge
                v-if="isMultiDoor"
                :text="selectedDoor"
                variant="outlineInfo"
                size="medium"
                type="button"
                :withDot="true"
              />
            </div>

            <div class="analysis-info-right">
              <b-button variant="outline-info me-2" :disabled="isChart" @click="handleDownload">
                <i class="icon-fill_download"></i>
              </b-button>
            </div>
          </div>

          <LineChart
            v-if="isChart"
            ref="lineChart"
            :labels="chartData.labels"
            :datasets="chartData.datasets"
            :options="chartOptions"
          />

          <McTable
            v-else
            ref="mcTable"
            :key="deliveryTableKey"
            :fields="computedFields"
            :apiClient="apiClient"
            :stickyHeader="true"
            :withCard="false"
            :hasCheckbox="false"
            :hasSelectAll="false"
          >
            <template #cell(sent_on)="{ value }">
              {{ value }}
            </template>
            <template #cell(longitude)="{ value }">
              {{ value }}
            </template>
            <template #cell(latitude)="{ value }">
              {{ value }}
            </template>
          </McTable>
        </div>
        <div
          v-if="showVerticalLine && isChart"
          class="vertical-line"
          :style="{
            left: verticalX + 'px',
            top: verticalLineTop + 'px',
            height: verticalLineHeight + 'px',
            borderColor: verticalLineColor,
          }"
        ></div>
        <div
          v-if="tooltipVisible && isChart"
          class="custom-tooltip"
          :style="{ left: tooltipPos.x + 'px', top: tooltipPos.y + 'px' }"
        >
          <div class="tooltip-header">
            {{ tooltipTitle }}
          </div>

          <div v-for="(item, i) in tooltipItems" :key="i" class="tooltip-item">
            <span class="dot" :style="{ background: item.color }"></span>
            <span class="label">{{ item.label }}:</span>
            <span class="value">{{ item.value }}</span>
          </div>
        </div>
        <div class="track-bar-container" :class="{ 'track-floating': sensorDataAnalysis }">
          <!-- Bar progres -->
          <div
            ref="trackBar"
            class="track-bar"
            @mousedown="startDrag"
            @touchstart.prevent="startDrag"
          >
            <div class="track-progress" :style="{ width: progressPercent + '%' }"></div>
            <div
              class="track-circle"
              :style="{ left: progressPercent + '%' }"
              @mousedown.stop="startDrag"
              @touchstart.stop.prevent="startDrag"
            ></div>
          </div>

          <!-- Time di bawah bar -->
          <div class="time-bottom">
            <span class="time-start">{{ formatTime(currentTime) }}</span>
            <span class="time-end">{{ formatTime(totalTime) }}</span>
          </div>

          <!-- Kontrol di tengah -->
          <div class="track-controls center-controls">
            <div class="controls-left">
              <select v-model="playSpeed" class="speed-select" @change="onPlaySpeedChange">
                <option v-for="s in speeds" :key="s" :value="s">{{ s }}x</option>
              </select>

              <button class="prev-btn" @click="rewind10">
                <i class="icon-outline_arrowhead-left"></i>
              </button>

              <button class="play-btn" @click="togglePlay">
                <i :class="isPlaying ? 'icon-fill_pause' : 'icon-fill_play'"></i>
              </button>

              <button class="next-btn" @click="forward10">
                <i class="icon-outline_arrowhead-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer ref="sidebarFooter" class="mc-delivery-track-sidebar-footer">
      <span>
        {{ 'Terakhir diupdate pada :' }}
        {{ formatIndexDate(currentDateTime).date + ', ' + formatIndexDate(currentDateTime).time }}
      </span>
      <div>
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('global.text.poweredBy') }} :
        </span>
        <figure class="d-inline-block mb-0">
          <img
            ref="imgCopyrightLogo"
            alt
            :src="getAsset('copyrightLogo', 'general')"
            @load="handleImageLoad()"
          />
        </figure>
      </div>
    </footer>
  </aside>
</template>
<script>
import LineChart from '@/components/Chart/Line'
import McBadge from '@/components/McBadge'
import McTable from '@/components/McTable'
import McAlert from '@/components/McAlert'

import vehicleIlustration from '@/assets/images/vehicle.svg'

import { mapGetters } from 'vuex'
import { formatIndexDate } from '@/helpers/tzDate'
import debounce from 'lodash'
import { EventBus } from '@/router/views/delivery/track/lib/event-bus.js'

import * as Delivery from '@/services/rest-api/lib/delivery/delivery-order'

export default {
  components: {
    LineChart,
    McBadge,
    McTable,
    McAlert,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    status: {
      type: String,
      default: null,
    },
    delivery: {
      type: Object,
      default: null,
    },
    doorActivityData: {
      type: Array,
      default: null,
    },
    currentDateTime: {
      type: String,
      default: null,
    },
    detailTripHistories: {
      type: Object,
      default: null,
    },
    hasTmsColdChainAccess: {
      type: Boolean,
      default: false,
    },
    isMultiChamber: {
      type: Boolean,
      default: false,
    },
    isMultiDoor: {
      type: Boolean,
      default: false,
    },
    uuid: {
      type: String,
      default: null,
    },
    hasFeatureEditActivityTrackDOMGM: {
      type: Boolean,
      default: false,
    },
    isEditingLocationTime: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['history-date-range-change'],
  data() {
    return {
      sidebarHeight: 0,
      resizeListener: null,
      isImageLoading: false,
      lastPosition: null,
      lastPositionTime: null,
      lastSpeed: null,
      lastTemperatureOne: null,
      lastTemperatureTwo: null,
      lastTemperatureThree: null,
      isLoadingLastPosition: true,
      vehicleIlustration,
      liveMarker: null,

      currentTime: 0,
      totalTime: 0,

      isPlaying: false,
      playSpeed: 1,
      speeds: [4, 2, 1.5, 1, 0.5, 0.25],

      isDragging: false,
      sensorDataAnalysis: false,
      deliveryTableKey: 0,
      isChart: true,

      tooltipVisible: false,
      tooltipTitle: '-',
      tooltipItems: [],
      tooltipPos: { x: 90, y: 400 },
      selectedDoor: 'Pintu 1',
      selectedTemperature: 'Suhu 1',
      historyDateRange: null,
      initialHistoryDateRange: null,
      historyDateRangeKey: 0,
      visibleChartDatasets: [],

      showVerticalLine: false,
      verticalX: 0,
      verticalLineTop: 0,
      verticalLineHeight: 0,
      verticalLineColor: '#99a1b1',
    }
  },
  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
    doNumber() {
      return this.delivery?.number ?? ''
    },
    isLoading() {
      return this.loading
    },
    pickupCompletedOn() {
      if (this.delivery?.shipment_type === 'TRANSIT') {
        const range = this.getTransitDateRange()
        return range?.start || null
      }
      const pickup = this.delivery?.delivery_order_activity?.pickup
      return pickup?.geofence_in || pickup?.completed_on || null
    },
    dropCompletedOn() {
      if (this.delivery?.shipment_type === 'TRANSIT') {
        const range = this.getTransitDateRange()
        return range?.end || null
      }
      const drop = this.delivery?.delivery_order_activity?.drop
      return drop?.geofence_out || drop?.completed_on || null
    },
    historyRangeEndDate() {
      if (this.delivery?.shipment_type === 'TRANSIT') {
        return this.dropCompletedOn || this.currentDateTime || new Date()
      }

      if (this.status === 'Terkirim') {
        return this.dropCompletedOn || this.currentDateTime || new Date()
      }

      return this.currentDateTime || new Date()
    },
    historyAvailableRangeText() {
      if (
        !['Diambil', 'Terkirim', 'Sedang Transit'].includes(this.status) ||
        !this.pickupCompletedOn
      )
        return ''

      const start = this.formatAvailableDateTime(this.pickupCompletedOn)
      let endReference = new Date(this.historyRangeEndDate)

      if (this.status === 'Diambil') {
        endReference = this.getPickupHistoryEndDate()
      } else if (this.hasFeatureEditActivityTrackDOMGM) {
        if (this.delivery?.shipment_type !== 'TRANSIT') {
          // Rentang filter tersedia adalah durasi asli + 3 hari
          endReference.setDate(endReference.getDate() + 3)
        }
      } else {
        if (
          this.status === 'Terkirim' &&
          !isNaN(endReference.getTime()) &&
          this.delivery?.shipment_type !== 'TRANSIT'
        ) {
          endReference.setHours(endReference.getHours() + 72)
        }
      }

      const end = this.formatAvailableDateTime(endReference)

      if (!start || !end) return ''
      return `${start} - ${end}`
    },
    historyDateRangeChanged() {
      if (!Array.isArray(this.historyDateRange) || this.historyDateRange.length !== 2) return false
      if (
        !Array.isArray(this.initialHistoryDateRange) ||
        this.initialHistoryDateRange.length !== 2
      ) {
        return false
      }

      return this.historyDateRange.some(
        (value, index) => value !== this.initialHistoryDateRange[index]
      )
    },
    progressPercent() {
      return (this.currentTime / this.totalTime) * 100
    },
    computedFields() {
      const fields = [
        {
          key: 'sent_on',
          label: 'Waktu',
          isSortable: false,
          isFirstRowClickable: false,
          isRedirectable: false,
          isShow: true,
          formatter: (value) => {
            return formatIndexDate(value).date + ',' + formatIndexDate(value).time
          },
        },
        {
          key: 'longitude',
          label: 'Longitude',
          isSortable: false,
          isShow: true,
        },
        {
          key: 'latitude',
          label: 'Latitude',
          isSortable: false,
          isShow: true,
        },
        {
          key: 'address',
          label: 'Detail Alamat',
          isSortable: false,
          isShow: true,
          isEllipsis: true,
          formatter: (value) => {
            return value || '-'
          },
        },
        {
          key: 'speed',
          label: 'Kecepatan',
          isSortable: false,
          isShow: true,
          formatter: (value) => {
            return value + ' Km/Jam'
          },
        },
        {
          key: 'acc',
          label: 'ACC',
          isSortable: false,
          isShow: true,
          formatter: (value) => {
            if (value === 1) return 'Nyala'
            if (value === 0) return 'Mati'
            return '-'
          },
        },
        {
          key: 'door',
          label: this.isMultiDoor
            ? this.selectedDoor === 'Pintu 1'
              ? 'Pintu 1'
              : this.selectedDoor === 'Pintu 2'
              ? 'Pintu 2'
              : 'Pintu'
            : 'Pintu',
          isSortable: false,
          isShow: this.hasTmsColdChainAccess,
          formatter: (value) => {
            return value === 0 ? 'Tutup' : 'Buka'
          },
        },
        {
          key: 'refrigerator',
          label: 'Refrigerator',
          isSortable: false,
          isShow: this.hasTmsColdChainAccess,
          formatter: (value) => {
            if (value === 1) return 'ON'
            if (value === 0) return 'OFF'
            if (value === null || value === undefined) return '-'
          },
        },
        {
          key: 'temperature',
          label: this.isMultiChamber
            ? this.selectedTemperature === 'Suhu 1'
              ? 'Suhu 1'
              : this.selectedTemperature === 'Suhu 2'
              ? 'Suhu 2'
              : this.selectedTemperature === 'Suhu 3'
              ? 'Suhu 3'
              : 'Suhu'
            : 'Suhu',
          isSortable: false,
          isShow: this.hasTmsColdChainAccess,
          formatter: (value) => {
            return value + ' °C'
          },
        },
      ]

      return fields.filter((f) => f.isShow)
    },
    chartData() {
      const data = this.detailTripHistories?.data?.filter((item) => !item.break) || []
      if (!data.length) return { labels: [], datasets: [] }
      const scaleMetrics = this.getChartScaleMetrics()

      const datasets = [
        {
          label: 'Kecepatan',
          data: data.map((i) => i.speed || 0),
          borderColor: '#8F49DE',
          backgroundColor: '#8F49DE',
          fill: false,
          tension: 0.2,
          pointRadius: 2,
          pointHoverRadius: 4,
          hidden: !this.isLegendDatasetVisible('Kecepatan'),
        },
      ]

      if (this.hasTmsColdChainAccess) {
        let temperatureData = []
        switch (this.selectedTemperature) {
          case 'Suhu 2':
            temperatureData = data.map((i) =>
              i.temperature2 === null || i.temperature2 === undefined
                ? null
                : scaleMetrics.tempStart +
                  (this.clampValue(
                    Number(i.temperature2),
                    scaleMetrics.tempAxisMin,
                    scaleMetrics.tempAxisMax
                  ) -
                    scaleMetrics.tempAxisMin) *
                    scaleMetrics.tempScale
            )
            break

          case 'Suhu 3':
            temperatureData = data.map((i) =>
              i.temperature3 === null || i.temperature3 === undefined
                ? null
                : scaleMetrics.tempStart +
                  (this.clampValue(
                    Number(i.temperature3),
                    scaleMetrics.tempAxisMin,
                    scaleMetrics.tempAxisMax
                  ) -
                    scaleMetrics.tempAxisMin) *
                    scaleMetrics.tempScale
            )
            break

          default:
            temperatureData = data.map((i) =>
              i.temperature === null || i.temperature === undefined
                ? null
                : scaleMetrics.tempStart +
                  (this.clampValue(
                    Number(i.temperature),
                    scaleMetrics.tempAxisMin,
                    scaleMetrics.tempAxisMax
                  ) -
                    scaleMetrics.tempAxisMin) *
                    scaleMetrics.tempScale
            )
            break
        }

        datasets.push({
          label: 'Suhu',
          data: temperatureData,
          borderColor: '#FF8A00',
          backgroundColor: '#FF8A00',
          fill: false,
          tension: 0.2,
          pointRadius: 2,
          pointHoverRadius: 4,
          customTooltip: true,
          hidden: !this.isLegendDatasetVisible('Suhu'),
        })

        const tempUpperLimit = this.delivery?.load_max_temperature
        const tempLowerLimit = this.delivery?.load_min_temperature

        if (tempUpperLimit !== null && tempUpperLimit !== undefined) {
          datasets.push({
            label: 'Batas Atas Suhu',
            data: Array(data.length).fill(
              scaleMetrics.tempStart +
                (this.clampValue(
                  Number(tempUpperLimit),
                  scaleMetrics.tempAxisMin,
                  scaleMetrics.tempAxisMax
                ) -
                  scaleMetrics.tempAxisMin) *
                  scaleMetrics.tempScale
            ),
            borderColor: '#f41d00',
            borderDash: [5, 5],
            fill: false,
            pointRadius: 0,
            borderWidth: 1,
            customTooltip: false,
            hidden: !this.isLegendDatasetVisible('Suhu'),
          })
        }

        if (tempLowerLimit !== null && tempLowerLimit !== undefined) {
          datasets.push({
            label: 'Batas Bawah Suhu',
            data: Array(data.length).fill(
              scaleMetrics.tempStart +
                (this.clampValue(
                  Number(tempLowerLimit),
                  scaleMetrics.tempAxisMin,
                  scaleMetrics.tempAxisMax
                ) -
                  scaleMetrics.tempAxisMin) *
                  scaleMetrics.tempScale
            ),
            borderColor: '#137c55',
            borderDash: [5, 5],
            fill: false,
            pointRadius: 0,
            borderWidth: 1,
            customTooltip: false,
            hidden: !this.isLegendDatasetVisible('Suhu'),
          })
        }

        let doorData = []

        switch (this.selectedDoor) {
          case 'Pintu 2':
            doorData = data.map((i) => {
              const v = i.door2
              if (v === 1) return scaleMetrics.doorOpen
              if (v === 0) return scaleMetrics.doorClosed
              return null
            })
            break

          default:
            doorData = data.map((i) => {
              const v = i.door1
              if (v === 1) return scaleMetrics.doorOpen
              if (v === 0) return scaleMetrics.doorClosed
              return null
            })
            break
        }

        datasets.push({
          label: 'Pintu',
          data: doorData,
          borderColor: '#4990E1',
          backgroundColor: '#4990E1',
          fill: false,
          steppedLine: true,
          tension: 0,
          pointRadius: 2,
          pointHoverRadius: 4,
          customTooltip: true,
          hidden: !this.isLegendDatasetVisible('Pintu'),
        })
      }

      const uniqueDates = [...new Set(data.map((i) => formatIndexDate(i.sentOn).date))]
      const sameDate = uniqueDates.length === 1

      const total = data.length
      const p25 = Math.round(total * 0.25)
      const p50 = Math.round(total * 0.5)
      const p75 = Math.round(total * 0.75)

      const labels = data.map((i, idx) => {
        const f = formatIndexDate(i.sentOn)
        const labelText = sameDate ? f.time : `${f.date} ${f.time}`

        if (idx === 0) return labelText
        if (idx === p25) return labelText
        if (idx === p50) return labelText
        if (idx === p75) return labelText
        if (idx === total - 1) return labelText

        return ''
      })

      return {
        labels,
        datasets,
      }
    },
    chartOptions() {
      const axisConfig = this.getChartAxisConfig()
      const vm = this

      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom',
          onClick: function (e, legendItem) {
            const labelsToToggle =
              legendItem.text === 'Suhu'
                ? ['Suhu', 'Batas Atas Suhu', 'Batas Bawah Suhu']
                : [legendItem.text]

            vm.toggleVisibleChartDatasets(labelsToToggle)
            vm.tooltipVisible = false
            vm.showVerticalLine = false
            vm.$nextTick(() => {
              if (vm.$refs.lineChart && vm.$refs.lineChart.renderChart) {
                vm.$refs.lineChart.renderChart(vm.chartData, vm.chartOptions)
              }
            })
          },
          labels: {
            boxWidth: 25,
            padding: 15,
            filter: function (legendItem, chartData) {
              const hiddenLabels = ['Batas Atas Suhu', 'Batas Bawah Suhu']
              return !hiddenLabels.includes(legendItem.text)
            },
          },
        },
        interaction: {
          mode: 'index',
          intersect: false,
        },
        tooltips: {
          enabled: false,
          mode: 'index',
          intersect: true,
          axis: 'x',
          custom: (tooltipModel) => this.handleHoverTooltip(tooltipModel),
        },
        scales: {
          xAxes: [
            {
              ticks: {
                autoSkip: false,
                maxRotation: 0,
                callback: function (value, index, values) {
                  return value === '' ? null : value
                },
              },
              gridLines: {
                color: '#eee',
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                min: 0,
                max: axisConfig.max,
                stepSize: axisConfig.stepSize,
                callback: axisConfig.tickCallback,
              },
              afterBuildTicks: (scale) => {
                scale.ticks = axisConfig.ticks
              },
              gridLines: {
                color: axisConfig.gridColor,
              },
            },
          ],
        },
        hover: {
          mode: 'nearest',
          intersect: false,
        },
        elements: {
          point: {
            hitRadius: 10,
          },
        },
      }
    },
    apiClient() {
      let filters = []
      if (this.hasTmsColdChainAccess) {
        let temperatureData = null
        switch (this.selectedTemperature) {
          case 'Suhu 2':
            temperatureData = 11
            break
          case 'Suhu 3':
            temperatureData = 36
            break
          default:
            temperatureData = 12
            break
        }
        filters.push(`temperature_code eq ${temperatureData}`)

        let doorData = null
        switch (this.selectedDoor) {
          case 'Pintu 2':
            doorData = 5
            break
          default:
            doorData = 4
            break
        }
        filters.push(`door_code eq ${doorData}`)
      }

      if (Array.isArray(this.historyDateRange) && this.historyDateRange.length === 2) {
        filters.push(`start_date eq ${this.historyDateRange[0]}`)
        filters.push(`end_date eq ${this.historyDateRange[1]}`)
      }

      return {
        get: Delivery.getDoTrackSensor(this.uuid, filters),
      }
    },
    disabledButtonHistoryTrip() {
      return this.detailTripHistories?.data?.length > 0
    },
    pickupActivityRaw() {
      const originId = this.delivery?.origin_address?.id
      const isTransit = this.delivery?.shipment_type === 'TRANSIT'

      return isTransit
        ? this.delivery?.transits?.find((t) => t.origin_address?.id === originId)
            ?.delivery_order_activity?.pickup
        : this.delivery?.delivery_order_activity?.pickup || {}
    },
    actualPickOutOfOrder() {
      return this.pickupActivityRaw?.is_activity_out_of_order
    },
    dropActivityRaw() {
      const destinationId = this.delivery?.destination_address?.id
      const isTransit = this.delivery?.shipment_type === 'TRANSIT'

      return isTransit
        ? this.delivery?.transits?.find((t) => t.destination_address?.id === destinationId)
            ?.delivery_order_activity?.drop
        : this.delivery?.delivery_order_activity?.drop || {}
    },
    actualDropOutOfOrder() {
      return this.dropActivityRaw?.is_activity_out_of_order
    },
  },
  watch: {
    detailTripHistories: {
      handler() {
        this.$nextTick(() => {
          if (this.$refs.lineChart && this.$refs.lineChart.renderChart) {
            this.resetVisibleChartDatasets()
            this.$refs.lineChart.renderChart(this.chartData, this.chartOptions)
          }
        })
      },
      deep: true,
      immediate: true,
    },
    selectedTemperature() {
      this.$nextTick(() => {
        clearInterval(this.timer)
        this.isPlaying = false
        this.currentTime = 0
        if (this.$refs.lineChart && this.$refs.lineChart.renderChart) {
          this.resetVisibleChartDatasets()
          this.$refs.lineChart.renderChart(this.chartData, this.chartOptions)
        }
        this.deliveryTableKey += 1
      })
    },
    selectedDoor() {
      this.$nextTick(() => {
        clearInterval(this.timer)
        this.isPlaying = false
        this.currentTime = 0
        if (this.$refs.lineChart && this.$refs.lineChart.renderChart) {
          this.resetVisibleChartDatasets()
          this.$refs.lineChart.renderChart(this.chartData, this.chartOptions)
        }
        this.deliveryTableKey += 1
      })
    },
    status: {
      handler() {
        this.initializeHistoryDateRange()
      },
      immediate: true,
    },
    pickupCompletedOn() {
      this.initializeHistoryDateRange()
    },
    historyDateRange(value) {
      if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
        this.$emit('history-date-range-change', value)
        this.deliveryTableKey += 1
      }
    },
  },
  mounted() {
    this.resizeListener = () => debounce(this.calculateCompHeight(true), 150)
    window.addEventListener('resize', this.resizeListener)
    // subscribe to playback updates from MapView
    EventBus.$on && EventBus.$on('playback:update', this.onPlaybackUpdate)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeListener)
    EventBus.$off && EventBus.$off('playback:update', this.onPlaybackUpdate)
  },
  methods: {
    formatIndexDate,
    getDefaultVisibleChartDatasets() {
      return this.hasTmsColdChainAccess ? ['Kecepatan', 'Suhu', 'Pintu'] : ['Kecepatan']
    },
    resetVisibleChartDatasets() {
      this.visibleChartDatasets = this.getDefaultVisibleChartDatasets()
    },
    getEffectiveVisibleChartDatasets() {
      return this.visibleChartDatasets.length
        ? this.visibleChartDatasets
        : this.getDefaultVisibleChartDatasets()
    },
    buildAxisTicks(min, max, step) {
      if (max < min) return []

      const ticks = []
      let current = min

      while (current <= max) {
        ticks.push(Number(current.toFixed(2)))
        current += step
      }

      if (!ticks.length || ticks[ticks.length - 1] !== Number(max.toFixed(2))) {
        ticks.push(Number(max.toFixed(2)))
      }

      return [...new Set(ticks)].sort((a, b) => a - b)
    },
    getSpeedAxisStep(maxValue) {
      if (maxValue <= 20) return 5
      if (maxValue <= 60) return 10
      return 20
    },
    getTemperatureDisplaySpan(minValue, maxValue) {
      const range = maxValue - minValue

      if (range <= 0) return 40
      return Math.max(range, 60)
    },
    clampValue(value, minValue, maxValue) {
      if (value < minValue) return minValue
      if (value > maxValue) return maxValue
      return value
    },
    getTemperatureAxisBounds(dataMin, dataMax) {
      const rawLowerLimit = this.delivery?.load_min_temperature
      const rawUpperLimit = this.delivery?.load_max_temperature
      const hasLowerLimit = rawLowerLimit !== null && rawLowerLimit !== undefined
      const hasUpperLimit = rawUpperLimit !== null && rawUpperLimit !== undefined

      let displayMin = dataMin
      let displayMax = dataMax

      if (hasLowerLimit) {
        displayMin = Math.min(dataMin, Number(rawLowerLimit))
      }

      if (hasUpperLimit) {
        displayMax = Math.max(dataMax, Number(rawUpperLimit))
      }

      if (displayMin > displayMax) {
        displayMin = Math.min(dataMin, dataMax)
        displayMax = Math.max(dataMin, dataMax)
      }

      if (displayMin === displayMax) {
        const pad = 1
        displayMin -= pad
        displayMax += pad
      }

      return {
        displayMin,
        displayMax,
      }
    },
    getTemperatureLimitValues() {
      const rawLowerLimit = this.delivery?.load_min_temperature
      const rawUpperLimit = this.delivery?.load_max_temperature

      return {
        lowerLimit:
          rawLowerLimit !== null && rawLowerLimit !== undefined ? Number(rawLowerLimit) : null,
        upperLimit:
          rawUpperLimit !== null && rawUpperLimit !== undefined ? Number(rawUpperLimit) : null,
      }
    },
    buildTemperatureLabelValues(axisMin, axisMax, dataMin, dataMax) {
      const { lowerLimit, upperLimit } = this.getTemperatureLimitValues()
      const candidates = [axisMin, dataMin, dataMax, axisMax]

      if (lowerLimit !== null && lowerLimit >= axisMin && lowerLimit <= axisMax) {
        candidates.push(lowerLimit)
      }

      if (upperLimit !== null && upperLimit >= axisMin && upperLimit <= axisMax) {
        candidates.push(upperLimit)
      }

      if (0 >= axisMin && 0 <= axisMax) {
        candidates.push(0)
      }

      return [...new Set(candidates.map((value) => Number(value.toFixed(2))))].sort((a, b) => a - b)
    },
    getSelectedTemperatureValue(item) {
      switch (this.selectedTemperature) {
        case 'Suhu 2':
          return item.temperature2
        case 'Suhu 3':
          return item.temperature3
        default:
          return item.temperature
      }
    },
    getVisibleChartGroups() {
      const allowedLabels = this.hasTmsColdChainAccess
        ? ['Kecepatan', 'Suhu', 'Pintu']
        : ['Kecepatan']
      const visibleLabels = this.getEffectiveVisibleChartDatasets()

      return allowedLabels.filter((label) => visibleLabels.includes(label))
    },
    toggleVisibleChartDatasets(labelsToToggle) {
      const currentVisible = this.getVisibleChartGroups()
      const orderedLabels = this.hasTmsColdChainAccess
        ? ['Kecepatan', 'Suhu', 'Pintu']
        : ['Kecepatan']
      const targetLabel = labelsToToggle.includes('Suhu') ? 'Suhu' : labelsToToggle[0]
      const isVisible = currentVisible.includes(targetLabel)

      const nextVisible = isVisible
        ? currentVisible.filter((label) => label !== targetLabel)
        : orderedLabels.filter((label) =>
            label === targetLabel ? true : currentVisible.includes(label)
          )

      this.visibleChartDatasets = nextVisible.length ? nextVisible : currentVisible
    },
    getChartScaleMetrics() {
      const data = this.detailTripHistories?.data?.filter((item) => !item.break) || []
      const speedValues = data.map((i) => Number(i.speed) || 0)
      let maxSpeed = Math.max(...speedValues, 0)
      const minSpeed = Math.min(...speedValues, 0)
      // Ensure at least a small range when all speeds are the same
      if (minSpeed === maxSpeed) {
        maxSpeed = Math.max(maxSpeed + 10, 10)
      }
      const speedStep = this.getSpeedAxisStep(maxSpeed)
      const speedTicks = this.buildAxisTicks(0, maxSpeed, speedStep)
      const visibleGroups = this.getVisibleChartGroups()
      const temperatureValues = data
        .map((item) => this.getSelectedTemperatureValue(item))
        .filter((value) => value !== null && value !== undefined && !isNaN(Number(value)))
        .map((value) => Number(value))
      const tempDataMin = temperatureValues.length ? Math.min(...temperatureValues) : 0
      const tempDataMax = temperatureValues.length ? Math.max(...temperatureValues) : 0
      const { displayMin: tempAxisMin, displayMax: tempAxisMax } = this.getTemperatureAxisBounds(
        tempDataMin,
        tempDataMax
      )
      const tempRange = tempAxisMax - tempAxisMin
      const tempDisplaySpan = this.getTemperatureDisplaySpan(tempAxisMin, tempAxisMax)
      const temperatureLabelValues = this.buildTemperatureLabelValues(
        tempAxisMin,
        tempAxisMax,
        tempDataMin,
        tempDataMax
      )

      let cursor = 0
      let tempScale = 1
      let tempStart = 0
      let tempEnd = 0
      let doorClosed = 0
      let doorOpen = 30
      let ticks = []
      const sectionSeparators = []

      if (visibleGroups.includes('Kecepatan')) {
        ticks.push(...speedTicks)
        cursor = maxSpeed
      }

      let tempTicks = []
      if (visibleGroups.includes('Suhu')) {
        tempStart = ticks.length ? cursor + 30 : 0
        if (ticks.length) sectionSeparators.push(tempStart)

        tempScale = tempRange > 0 ? tempDisplaySpan / tempRange : 1
        tempTicks = temperatureLabelValues.map((tick) =>
          Number((tempStart + (tick - tempAxisMin) * tempScale).toFixed(2))
        )
        ticks.push(...tempTicks)
        tempEnd = Number((tempStart + tempDisplaySpan).toFixed(2))
        cursor = tempEnd
      }

      if (visibleGroups.includes('Pintu')) {
        doorClosed = ticks.length ? cursor + 30 : 0
        if (ticks.length) sectionSeparators.push(doorClosed)

        doorOpen = doorClosed + 30
        ticks.push(doorClosed, doorOpen)
        cursor = doorOpen
      }

      if (!ticks.length) ticks = [0]

      return {
        max: ticks[ticks.length - 1],
        stepSize: speedStep,
        ticks,
        tempScale,
        tempAxisMin,
        tempAxisMax,
        tempStart,
        tempEnd,
        doorClosed,
        doorOpen,
        tickCallback: (value) => {
          if (visibleGroups.includes('Kecepatan') && speedTicks.includes(value)) return `${value}`
          if (visibleGroups.includes('Suhu') && tempTicks.includes(value))
            return `${Number((((value - tempStart) / tempScale) + tempAxisMin).toFixed(2))}`
          if (visibleGroups.includes('Pintu') && value === doorClosed) return 'Tutup'
          if (visibleGroups.includes('Pintu') && value === doorOpen) return 'Buka'
          return ''
        },
        gridColor: (context) => {
          const y = context.tick.value
          if (sectionSeparators.includes(y)) return '#ccc'
          return '#eee'
        },
      }
    },
    isLegendDatasetVisible(label) {
      return this.getEffectiveVisibleChartDatasets().includes(label)
    },
    getChartAxisConfig() {
      const scaleMetrics = this.getChartScaleMetrics()

      return {
        max: scaleMetrics.max,
        stepSize: scaleMetrics.stepSize,
        ticks: scaleMetrics.ticks,
        tickCallback: scaleMetrics.tickCallback,
        gridColor: scaleMetrics.gridColor,
      }
    },
    getTransitDateRange() {
      if (this.delivery?.shipment_type !== 'TRANSIT') return null

      const transits = this.delivery?.transits || []
      if (transits.length === 0) return null

      const firstLeg = transits[0]
      const firstPickup = firstLeg?.delivery_order_activity?.pickup

      let latestLeg = null
      let latestActivityType = null

      for (let i = transits.length - 1; i >= 0; i--) {
        const leg = transits[i]
        const activity = leg.delivery_order_activity
        if (activity?.drop?.geofence_out || activity?.drop?.completed_on) {
          latestLeg = leg
          latestActivityType = 'drop'
          break
        }
        if (activity?.pickup?.geofence_in || activity?.pickup?.completed_on) {
          latestLeg = leg
          latestActivityType = 'pickup'
          break
        }
      }

      if (!latestLeg) return null

      let start, end

      if (this.status === 'Terkirim' && latestLeg === transits[transits.length - 1]) {
        // Case 5: FO-3 selesai drop barang (DELIVERED)
        start = firstPickup?.geofence_in || firstPickup?.completed_on
        end =
          latestLeg?.delivery_order_activity?.drop?.geofence_out ||
          latestLeg?.delivery_order_activity?.drop?.completed_on
      } else {
        // Case 1-4
        start = firstPickup?.geofence_in || firstPickup?.completed_on
        if (latestActivityType === 'drop') {
          const drop = latestLeg?.delivery_order_activity?.drop
          end = drop?.geofence_out || drop?.completed_on
        } else {
          const pickup = latestLeg?.delivery_order_activity?.pickup
          end = pickup?.geofence_out || pickup?.completed_on
        }
      }

      return { start, end }
    },
    initializeHistoryDateRange() {
      if (
        !['Diambil', 'Terkirim', 'Sedang Transit'].includes(this.status) ||
        !this.pickupCompletedOn
      )
        return

      const startDate = this.toLocalISOString(this.pickupCompletedOn)
      let endReference = new Date(this.historyRangeEndDate)

      if (this.status === 'Diambil') {
        endReference = this.getPickupHistoryEndDate()
      } else if (this.hasFeatureEditActivityTrackDOMGM) {
        if (this.delivery?.shipment_type !== 'TRANSIT') {
          const threeDaysAfterStart = new Date(this.pickupCompletedOn)
          threeDaysAfterStart.setDate(threeDaysAfterStart.getDate() + 3)

          if (endReference > threeDaysAfterStart) {
            endReference = threeDaysAfterStart
          }
        }
      } else {
        if (
          this.status === 'Terkirim' &&
          !isNaN(endReference.getTime()) &&
          this.delivery?.shipment_type !== 'TRANSIT'
        ) {
          endReference.setHours(endReference.getHours() + 72)
        }
      }

      const endDate = this.toLocalISOString(endReference)
      if (!startDate || !endDate) return

      if (Array.isArray(this.historyDateRange) && this.historyDateRange.length) {
        const isBaseDataChanged =
          !this.initialHistoryDateRange ||
          this.initialHistoryDateRange[0] !== startDate ||
          this.initialHistoryDateRange[1] !== endDate

        if (!isBaseDataChanged) return
        if (this.status !== 'Terkirim' && this.historyDateRangeChanged) return
      }

      this.historyDateRange = [startDate, endDate]
      this.initialHistoryDateRange = [startDate, endDate]
      this.historyDateRangeKey += 1
    },
    toLocalISOString(value) {
      const date = value instanceof Date ? value : new Date(value)
      if (isNaN(date.getTime())) return null

      const tzOffset = -date.getTimezoneOffset()
      const sign = tzOffset >= 0 ? '+' : '-'
      const pad = (n) => `${Math.floor(Math.abs(n))}`.padStart(2, '0')
      const hours = pad(tzOffset / 60)
      const minutes = pad(tzOffset % 60)

      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(
        date.getHours()
      )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}.000${sign}${hours}:${minutes}`
    },
    getPickupHistoryEndDate() {
      const nowReference = new Date(this.currentDateTime || new Date())
      const pickupReference = new Date(this.pickupCompletedOn)

      if (isNaN(nowReference.getTime())) return new Date()
      if (isNaN(pickupReference.getTime())) return nowReference

      const threeDaysAfterPickup = new Date(pickupReference)
      threeDaysAfterPickup.setHours(threeDaysAfterPickup.getHours() + 72)

      return nowReference > threeDaysAfterPickup ? threeDaysAfterPickup : nowReference
    },
    disabledHistoryDate(date) {
      if (
        !['Diambil', 'Terkirim', 'Sedang Transit'].includes(this.status) ||
        !this.pickupCompletedOn
      )
        return false

      const start = new Date(this.pickupCompletedOn)
      let end = new Date(this.historyRangeEndDate)

      if (this.status === 'Diambil') {
        end = this.getPickupHistoryEndDate()
      } else if (this.hasFeatureEditActivityTrackDOMGM) {
        if (this.delivery?.shipment_type !== 'TRANSIT') {
          // Izinkan pemilihan tanggal sampai durasi asli + 3 hari
          end.setDate(end.getDate() + 3)
        }
      } else {
        if (this.status === 'Terkirim' && this.delivery?.shipment_type !== 'TRANSIT') {
          end.setHours(end.getHours() + 72)
        }
      }

      if (isNaN(start.getTime()) || isNaN(end.getTime())) return false

      const startDay = new Date(start)
      startDay.setHours(0, 0, 0, 0)

      const endDay = new Date(end)
      endDay.setHours(23, 59, 59, 999)

      const selectedDay = new Date(date)
      return selectedDay < startDay || selectedDay > endDay
    },
    formatAvailableDateTime(value) {
      const date = value instanceof Date ? value : new Date(value)
      if (isNaN(date.getTime())) return ''

      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'Mei',
        'Jun',
        'Jul',
        'Agu',
        'Sep',
        'Okt',
        'Nov',
        'Des',
      ]
      const pad = (n) => `${n}`.padStart(2, '0')

      return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()} ${pad(
        date.getHours()
      )}:${pad(date.getMinutes())}`
    },
    clickToggle() {
      const sidebar = this.$refs.sidebarBody
      const isFullMap = document.body.classList.contains('mc-full-map')
      document.body.classList.toggle('mc-full-map')

      if (sidebar && isFullMap) {
        this.$nextTick(() => {
          sidebar.scrollTo({ top: 0 })
          this.calculateModalHeight(true)
        })
        if (window.innerWidth < 890) {
          const controlLeft = document.getElementsByClassName('control-left')
          Array.from(controlLeft).forEach((el) => {
            el.style.bottom = '460px'
          })
          const controlRight = document.getElementsByClassName('control-right')
          Array.from(controlRight).forEach((el) => {
            el.style.bottom = '460px'
          })
        }
      } else {
        this.clearSidebarStyle()
      }

      if (this.sensorDataAnalysis) {
        this.sensorDataAnalysis = true
      } else {
        this.sensorDataAnalysis = false
      }
    },
    calculateCompHeight(resize = false) {
      if (window.innerWidth >= 890) {
        this.clearSidebarStyle()
        const mapWrapper = document.getElementById('livetrack-map')
        const sidebarWrapper = this.$refs.sidebarWrapper
        if (mapWrapper && sidebarWrapper) {
          mapWrapper.style.height = ''
          sidebarWrapper.style.height = ''
        }
        return
      }

      if (resize) {
        const sidebarEl = this.$refs.sidebarBody
        if (sidebarEl) {
          sidebarEl.scrollTo({ top: 0 })
        }
      }

      this.calculateModalHeight()
      this.calculateMapHeight()
    },
    calculateMapHeight() {
      const mapWrapper = document.getElementById('livetrack-map')

      if (mapWrapper) {
        mapWrapper.style.height = `calc(100vh - ${this.sidebarHeight}px)`
      }
    },
    calculateModalHeight(withAnimation = false) {
      const isFullMap = document.body.classList.contains('mc-full-map')
      const sidebarTime = this.$refs.mobileSidebarEstimate || this.$refs.mobileSidebarActual
      const sidebarToggle = this.$refs.sidebarToggle
      const sidebarHeader = this.$refs.sidebarHeader
      const sidebarStatus = this.$refs.sidebarStatus
      const sidebarFooter = this.$refs.sidebarFooter
      const sidebar = this.$refs.sidebar
      const sidebarWrapper = this.$refs.sidebarWrapper

      let sidebarHeight
      if (
        sidebarTime &&
        sidebarToggle &&
        sidebarHeader &&
        sidebarStatus &&
        sidebarFooter &&
        !isFullMap
      ) {
        sidebarHeight =
          sidebarTime.offsetHeight +
          sidebarToggle.offsetHeight +
          sidebarHeader.offsetHeight +
          sidebarStatus.offsetHeight +
          30 +
          sidebarFooter.offsetHeight
      }

      if (sidebar && sidebarWrapper) {
        if (!withAnimation) {
          sidebar.style.transition = 'none'
        }

        sidebarWrapper.style.height = `calc(100% - ${sidebarFooter.offsetHeight}px)`

        if (sidebarHeight) {
          this.sidebarHeight = sidebarHeight
          sidebar.style.height = `${sidebarHeight}px`
          sidebar.style.top = `calc(100% - ${sidebarHeight}px)`
        }

        if (!withAnimation) {
          sidebar.style.transition = ''
        }
      }
    },
    clearSidebarStyle() {
      if (window.innerWidth < 890) {
        const controlLeft = document.getElementsByClassName('control-left')
        Array.from(controlLeft).forEach((el) => {
          el.style.bottom = 'calc(100% - 90px)'
        })
        const controlRight = document.getElementsByClassName('control-right')
        Array.from(controlRight).forEach((el) => {
          el.style.bottom = 'calc(100% - 90px)'
        })
      }
      const sidebar = this.$refs.sidebar
      if (sidebar) {
        sidebar.style.height = ''
        sidebar.style.top = ''
      }
    },
    handleImageLoad() {
      this.isImageLoading = false
    },
    val(v) {
      if (v === 0) return 0
      return v !== null && v !== undefined && v !== '' ? v : '-'
    },
    formatDateTime() {
      const sentOn = this.liveMarker?.sentOn

      if (!sentOn) return '-'

      const f = this.formatIndexDate(sentOn)

      if (!f) return '-'

      return `${this.val(f.date)}, ${this.val(f.time)}`
    },
    startDrag(event) {
      this.isDragging = true
      document.addEventListener('mousemove', this.onDrag)
      document.addEventListener('mouseup', this.stopDrag)
      document.addEventListener('touchmove', this.onDrag, { passive: false })
      document.addEventListener('touchend', this.stopDrag)
      this.updateDragPosition(event)
      EventBus.$emit && EventBus.$emit('dragStart', event)
    },
    onDrag(event) {
      if (!this.isDragging) return
      if (event && event.preventDefault) event.preventDefault()
      this.updateDragPosition(event)
    },
    stopDrag() {
      if (!this.isDragging) return
      this.isDragging = false
      document.removeEventListener('mousemove', this.onDrag)
      document.removeEventListener('mouseup', this.stopDrag)
      document.removeEventListener('touchmove', this.onDrag)
      document.removeEventListener('touchend', this.stopDrag)
      EventBus.$emit && EventBus.$emit('seek', this.currentTime)
      EventBus.$emit && EventBus.$emit('dragEnd', this.currentTime)
    },
    updateDragPosition(event) {
      const bar = this.$refs.trackBar
      if (!bar) return
      const rect = bar.getBoundingClientRect()
      const clientX = event && event.touches ? event.touches[0].clientX : event.clientX
      if (typeof clientX !== 'number') return
      let offsetX = clientX - rect.left
      if (offsetX < 0) offsetX = 0
      if (offsetX > rect.width) offsetX = rect.width

      const percent = rect.width > 0 ? offsetX / rect.width : 0
      const total = this.totalTime && this.totalTime > 0 ? this.totalTime : 1
      this.currentTime = percent * total
      EventBus.$emit && EventBus.$emit('seek', this.currentTime)
    },
    togglePlay() {
      this.isPlaying = !this.isPlaying
      EventBus.$emit && EventBus.$emit('togglePlay', { isPlaying: this.isPlaying })
    },
    rewind10() {
      this.currentTime = Math.max(0, this.currentTime - 10)
      EventBus.$emit && EventBus.$emit('seek', this.currentTime)
    },
    forward10() {
      this.currentTime = Math.min(this.totalTime, this.currentTime + 10)
      EventBus.$emit && EventBus.$emit('seek', this.currentTime)
    },
    onPlaySpeedChange() {
      EventBus.$emit && EventBus.$emit('playSpeed', this.playSpeed)
    },
    onPlaybackUpdate(payload) {
      if (payload == null) return
      if (typeof payload.currentTime === 'number') this.currentTime = payload.currentTime
      if (typeof payload.totalTime === 'number') this.totalTime = payload.totalTime
      if (typeof payload.isPlaying === 'boolean') this.isPlaying = payload.isPlaying
      if (payload.liveMarker) this.liveMarker = payload.liveMarker
    },
    formatTime(sec) {
      const m = Math.floor(sec / 60)
      const s = Math.floor(sec % 60)
        .toString()
        .padStart(2, '0')
      return `${m}:${s}`
    },
    handleDownload() {
      let filters = []
      if (this.hasTmsColdChainAccess) {
        let temperatureData = null
        switch (this.selectedTemperature) {
          case 'Suhu 2':
            temperatureData = 11
            break
          case 'Suhu 3':
            temperatureData = 36
            break
          default:
            temperatureData = 12
            break
        }
        filters.push(`temperature_code eq ${temperatureData}`)
        let doorData = null
        switch (this.selectedDoor) {
          case 'Pintu 2':
            doorData = 5
            break
          default:
            doorData = 4
            break
        }
        filters.push(`door_code eq ${doorData}`)
      }

      if (Array.isArray(this.historyDateRange) && this.historyDateRange.length === 2) {
        filters.push(`start_date eq ${this.historyDateRange[0]}`)
        filters.push(`end_date eq ${this.historyDateRange[1]}`)
      }

      const params = { format: 'excel' }
      if (filters.length > 0) {
        params.filters = filters.join(', ')
      }

      window.open(
        `${process.env.VUE_APP_API_ORDER_URL}/delivery-order/track/${
          this.uuid
        }/sensor?${new URLSearchParams(params).toString()}`,
        '_self'
      )
    },
    toggleAnalysis(params) {
      this.isChart = params === 'chart'
      if (params === 'table') {
        this.tooltipVisible = false
      }
    },
    getChartInstance() {
      const comp = this.$refs.lineChart
      if (!comp) return null

      return comp._chart || comp.chart || (comp.$data && comp.$data._chart) || null
    },
    getPrimaryVisibleDatasetIndex(chart = this.getChartInstance()) {
      if (!chart?.data?.datasets?.length) return -1

      return chart.data.datasets.findIndex((dataset) => {
        if (dataset.hidden) return false

        if (dataset.label === 'Kecepatan') return this.isLegendDatasetVisible('Kecepatan')
        if (dataset.label === 'Suhu') return this.isLegendDatasetVisible('Suhu')
        if (dataset.label === 'Pintu') return this.isLegendDatasetVisible('Pintu')

        return false
      })
    },
    adjustTooltipPosition(origX, origY, verticalX) {
      const containerRect = this.$el.getBoundingClientRect()
      const containerRight = containerRect.right

      const getTooltipWidth = () => {
        const el = this.$el.querySelector('.custom-tooltip')
        if (el) return el.offsetWidth
        return 200
      }

      const tooltipWidth = getTooltipWidth()
      const margin = 10

      let left = verticalX + margin

      const rightEdge = containerRect.left + left + tooltipWidth
      if (rightEdge > containerRight - 10) {
        left = verticalX - tooltipWidth - margin
        if (left < 10) left = 10
      }

      return {
        x: left,
        y: origY,
      }
    },
    handleHoverTooltip(tooltipModel) {
      if (this.isPlaying) return

      if (tooltipModel.opacity === 0) {
        this.tooltipVisible = false
        this.showVerticalLine = false
        return
      }

      const chart = this.getChartInstance()
      if (!chart || !chart.canvas) {
        this.tooltipVisible = false
        this.showVerticalLine = false
        return
      }

      const dp = tooltipModel.dataPoints?.[0]
      if (!dp) return

      const index = dp.index
      const pointData = this.detailTripHistories.data.filter((i) => !i.break)[index]
      if (!pointData) return

      const primaryDatasetIndex = this.getPrimaryVisibleDatasetIndex(chart)
      if (primaryDatasetIndex === -1) {
        this.tooltipVisible = false
        this.showVerticalLine = false
        return
      }

      const meta = chart.getDatasetMeta(primaryDatasetIndex)
      const point = meta && meta.data && meta.data[index]
      if (!point) {
        this.tooltipVisible = false
        this.showVerticalLine = false
        return
      }

      const model = point._model || point
      const pointX = model.x

      const chartRect = chart.canvas.getBoundingClientRect()
      const containerRect = this.$el.getBoundingClientRect()

      const posX = Math.round(pointX + (chartRect.left - containerRect.left) + 10)
      const posY = Math.round(chartRect.top - containerRect.top + 30)

      const chartArea = chart.chartArea
      this.verticalLineTop = Math.round(chartRect.top - containerRect.top + 6)
      this.verticalLineHeight = chartArea.bottom - chartArea.top
      this.verticalX = Math.round(pointX + (chartRect.left - containerRect.left))

      const f = this.formatIndexDate(pointData.sentOn)
      this.tooltipTitle = `${f.date} ${f.time}`

      const items = []
      if (this.isLegendDatasetVisible('Kecepatan')) {
        items.push({
          color: '#8F49DE',
          label: 'Kecepatan',
          value: `${pointData.speed} Km/Jam`,
        })
      }

      if (this.hasTmsColdChainAccess && this.isLegendDatasetVisible('Suhu')) {
        let tempVal = null
        switch (this.selectedTemperature) {
          case 'Suhu 2':
            tempVal = pointData.temperature2
            break
          case 'Suhu 3':
            tempVal = pointData.temperature3
            break
          default:
            tempVal = pointData.temperature
        }

        items.push({
          color: '#FF8A00',
          label: 'Suhu',
          value: tempVal == null ? '-' : `${tempVal}°C`,
        })
      }

      if (this.hasTmsColdChainAccess && this.isLegendDatasetVisible('Pintu')) {
        const doorVal = this.selectedDoor === 'Pintu 2' ? pointData.door2 : pointData.door1

        let doorLabel = '-'

        if (doorVal === 1) {
          doorLabel = 'Buka'
        } else if (doorVal === 0) {
          doorLabel = 'Tutup'
        }

        items.push({
          color: '#4990E1',
          label: 'Pintu',
          value: doorLabel,
        })
      }

      this.tooltipItems = items
      this.$nextTick(() => {
        const adjusted = this.adjustTooltipPosition(posX, posY, this.verticalX)
        this.tooltipPos = { x: adjusted.x, y: adjusted.y }
        this.tooltipVisible = true
        this.showVerticalLine = true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.date-range-history-mobile {
  width: 100%;
  position: relative;

  :deep(.mx-datepicker) {
    width: 100% !important;
  }

  .date-range-history-mobile__indicator {
    position: absolute;
    top: 0;
    right: 0;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #ff2b1c;
    border: 2px solid #fff;
    transform: translate(45%, -45%);
    pointer-events: none;
    z-index: 2;
  }
}

.track-bar-container {
  width: 100%;
  position: relative;
}

.track-floating {
  position: sticky;
  bottom: 0;
  z-index: 50;
  background: white;
}

/* Bar progress */
.track-bar {
  width: 100%;
  height: 8px;
  background: #c7d4e8;
  border-radius: 4px;
  position: relative;
}

/* Time bawah */
.time-bottom {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
  font-size: 12px;
  color: #333;
  padding: 0 4px;
}

.time-start {
  text-align: left;
}

.time-end {
  text-align: right;
}

/* Kontrol ditengah */
.track-controls {
  width: 100%;
  display: flex;
  justify-content: left;
  margin-top: 14px;
}

.center-controls .controls-left {
  display: flex;
  align-items: center;
  gap: 35px;
}

/* Tombol playback */
.play-btn,
.prev-btn,
.next-btn {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 35px;
    &::before {
      border: none;
      background-color: transparent;
    }
  }
}

.play-btn {
  background: #0d47a1;
  color: #fff;
}

/* Speed select */
.speed-select {
  padding: 4px 6px;
  border-radius: 6px;
  border: 1px solid #ccc;
}

.vertical-line {
  position: absolute;
  width: 0;
  border-left: 2px dashed;
  pointer-events: none;
  z-index: 5;
}

.custom-tooltip {
  position: absolute;
  left: 95px;
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  padding-bottom: 5px;
  width: 200px;

  .tooltip-header {
    background: #0d4491;
    color: #fff;
    padding: 8px 12px;
    border-radius: 8px 8px 0 0;
  }

  .tooltip-item {
    display: flex;
    align-items: center;
    padding: 5px;

    .dot {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      display: inline-block;
      margin-right: 8px;
    }

    .label {
      color: #555;
      margin-right: 4px;
    }

    .value {
      font-weight: 600;
      color: #333;
    }
  }
}

.sensor-controls select {
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid $teal-100;
  background: $white;
}
</style>
